import styled from 'styled-components';

const isVisible = ({ preTransition }: { preTransition: boolean }) => {
  if (preTransition)
    return {
      opacity: 0,
      'pointer-events': 'none',
    };
  return {
    opacity: 1,
  };
};

export const FlexContainer = styled.div<{ preTransition: boolean }>`
  ${isVisible};
  display: flex;
  width: 100%;
  transition-delay: 100ms;
  transition: opacity 400ms ease-in-out;
`;

export default FlexContainer;
